import { render, staticRenderFns } from "./DossierUpdates.vue?vue&type=template&id=67e3ee60&scoped=true&"
import script from "./DossierUpdates.vue?vue&type=script&setup=true&lang=js&"
export * from "./DossierUpdates.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DossierUpdates.vue?vue&type=style&index=0&id=67e3ee60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e3ee60",
  null
  
)

export default component.exports